import {Box} from '@mui/material';
import ProductCard from '../base/ProductCard/ProductCard';
const GoldBoxItem = ({ item }) => {
    return (
        <Box
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            sx={{ 
                width: "100%",
                margin: "5px 0",
            }}
        >
            <ProductCard item={item}/>
        </Box>
    );
};

export default GoldBoxItem;
